module.exports = __webpack_public_path__ + "img/wz-8-6-1.55d56c45.jpg";